import React from "react";

import { useLanguage } from "../context/LanguageContext";



const DEFAULT_LOGO = "/logo_sd.png";



/**

 * Brand logo from contactInfo (override în admin) sau default.

 * Header: logoUrl + branding.logoHeightPx

 * Footer: footerLogoUrl sau logoUrl + branding.footerLogoHeightPx

 *

 * @param {{ variant?: "header" | "footer" }} props

 */

export default function SiteLogo({ variant = "header" }) {

  const { contactInfo, branding } = useLanguage();

  const isFooter = variant === "footer";



  const headerUrl =

    typeof contactInfo?.logoUrl === "string" && contactInfo.logoUrl.trim() ? contactInfo.logoUrl.trim() : DEFAULT_LOGO;

  const footerOverride =

    typeof contactInfo?.footerLogoUrl === "string" && contactInfo.footerLogoUrl.trim()

      ? contactInfo.footerLogoUrl.trim()

      : "";

  const src = isFooter ? footerOverride || headerUrl : headerUrl;



  const w = isFooter ? branding?.footerLogoWidthPx : branding?.logoWidthPx;

  const h = isFooter ? branding?.footerLogoHeightPx : branding?.logoHeightPx;



  const hasW = typeof w === "number" && w > 0;

  const hasH = typeof h === "number" && h > 0;

  const customSize = hasW || hasH;



  const style = customSize

    ? {

        objectFit: "contain",

        ...(hasH && !hasW ? { height: h, width: "auto" } : {}),

        ...(hasW && !hasH ? { width: w, height: "auto" } : {}),

        ...(hasW && hasH ? { width: w, height: h } : {}),

      }

    : undefined;



  const className = customSize

    ? isFooter

      ? "max-w-[min(92vw,420px)] object-contain object-left"

      : "max-w-[min(92vw,560px)] object-contain object-left"

    : isFooter

      ? "h-9 w-auto max-w-[min(88vw,260px)] md:h-10 object-contain object-left"

      : "h-7 w-auto max-w-[min(46vw,168px)] sm:h-8 sm:max-w-[220px] object-contain object-left";



  return (

    <img

      src={src}

      alt="Social Destiny"

      className={className}

      style={style}

      decoding="async"

      loading={variant === "header" ? "eager" : "lazy"}

      onError={(e) => {

        if (e.currentTarget.getAttribute("src")?.includes(DEFAULT_LOGO)) return;

        e.currentTarget.src = DEFAULT_LOGO;

      }}

      data-testid={variant === "header" ? "site-logo-header" : "site-logo-footer"}

    />

  );

}

